import React, {useContext} from "react";
import S from "./FundTabNavigation.styled";
import { FundComponentStructureInterface } from "../../FundComponentStructure";
import ArrowDown from "@/assets/arrow-down.svg";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import FundContext from "@/components/FundSingle/FundProvider";

const FundTabNavigation: React.FC = () => {

    const { currentTabIndex, setCurrentTabIndex, fundComponentDataStructures } = useContext(FundContext);

    const onPressTab = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, index: number) => {
        if (currentTabIndex === index) return;
        if (fundComponentDataStructures[index].type === "link") {
            // If its an anchor link, preventDefault and smooth scroll
            if (fundComponentDataStructures[index].url?.includes('#')) {
                e.preventDefault();
                var element = document.getElementById(fundComponentDataStructures[index].url?.replace('#', ''));
                
                window.scrollTo({
                    top: element?.getBoundingClientRect().top + window.scrollY - 100,
                    behavior: 'smooth'
                });

                return;
            }
        }

        e.preventDefault();
        setCurrentTabIndex && setCurrentTabIndex(index);
        
        var fundComponentY = document.getElementById('fundComponent')?.getBoundingClientRect().top;
        if (fundComponentY) {
            window.scrollTo({
                top: fundComponentY + window.scrollY - 100,
                behavior: 'smooth'
            });
        }
    }

    const renderTab = (tab: FundComponentStructureInterface, index: number) => {
        const isActive = currentTabIndex === index;

        switch (tab.type) {
            case "components":
                return (
                    <S.FundTabsTab
                        key={index}
                        isActive={isActive}
                        onClick={(e) => onPressTab(e, index)}
                    >
                        {tab.label}
                    </S.FundTabsTab>
                );
            case "link":
                return (
                    <S.FundTabsTabLink
                        key={index}
                        href={tab.url}
                        isActive={isActive}
                        onClick={(e) => onPressTab(e, index)}
                    >
                        {tab.label}

                        {tab.url && tab.url.includes('#') && (
                            <ArrowDown />
                        )}
                    </S.FundTabsTabLink>
                );
            case "seperator":
                return <S.FundTabSeperator key={index} />;
            default:
                return null;
        }
    };

    return (
        <S.FundTabsWrapper id="fundTabs">
            <S.FundTabContainer>
                <Swiper
                    slidesPerView="auto"
                    spaceBetween={20}
                >  
                {fundComponentDataStructures?.map(
                    (tab, index) =>
                    <SwiperSlide key={index} style={{width: 'auto'}}>
                        {renderTab(tab, index)}
                    </SwiperSlide>
                )}
                </Swiper>
            </S.FundTabContainer>
        </S.FundTabsWrapper>
    );
};

export default FundTabNavigation;
